export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/agreement',
      method: 'GET'
    }]
  },
  add: {
    funKey: 'add',
    name: '新增',
    apis: [{
      path: '/basis/agreement',
      method: 'POST'
    },
    {
      path: '/basis/worker',
      method: 'GET'
    }]
  },
  update: {
    funKey: 'edit',
    name: '修改',
    apis: [{
      path: '/basis/agreement/{id}',
      method: 'PUT'
    },
    {
      path: '/basis/worker',
      method: 'GET'
    }]
  },
  del: {
    funKey: 'del',
    name: '删除',
    apis: [{
      path: '/basis/agreement/{id}',
      method: 'DELETE'
    }]
  },
  data_file: {
    funKey: 'data_file',
    name: '扫描件'
  },
  getDataFile: {
    funKey: 'getDataFile',
    name: '获取扫描件'
  },
  updateDataFile: {
    funKey: 'updateDataFile',
    name: '上传扫描件',
    apis: [{
      path: '/basis/agreement/{id}',
      method: 'PUT'
    }]
  },
  downDataFile: {
    funKey: 'downDataFile',
    name: '下载扫描件'
  },
  delDataFile: {
    funKey: 'delDataFile',
    name: '删除扫描件',
    apis: [{
      path: '/basis/agreement/{id}',
      method: 'PUT'
    }]
  }
}